// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// On Render
const BASE_API = 'https://compai-admin-backend.onrender.com/'

// On Heroku
// const BASE_API = 'https://compai-admin-backend.herokuapp.com/'

// On Localhost
// const BASE_API = 'http://127.0.0.1:8000/'

export const environment = {
  production: false,

  apiUrl: BASE_API + "api/",
  appsUrl: BASE_API + "apps/",

  renderRegions: {
    oregon: '',
    frankfurt: '-frankfurt'
  },

  heroku: 'https://compai-admin-backend.herokuapp.com/',

  // apiUrl: "https://milyiyo.pythonanywhere.com/api/"
  // apiUrl: "https://django-admin-app.azurewebsites.net/api/"

  sleepDelay: 500,

  SUPABASE_URL: 'https://roiczlviczojettkzcae.supabase.co',
  SUPABASE_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJvaWN6bHZpY3pvamV0dGt6Y2FlIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzA5NjYwOTUsImV4cCI6MTk4NjU0MjA5NX0.hO1Du9BBWkZkQJE70DPKQdy32VKceSZwwr3dsAqSDPQ'
};

export function applyRegion(url: string, suffix: string): string {
  return url.replace('.onrender', suffix + '.onrender');
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
